import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useLocationStore = defineStore(
  'location',
  () => {
    const canDeliver = ref<boolean | null>(null)
    const showLocationDialog = ref<boolean>(false)

    return { canDeliver, showLocationDialog }
  },
  { persist: true }
)
